module.exports = ".daterangepicker-input{height:34px;width:215px;padding-left:5px}.employee-type-switch{display:flex}.employee-type-switch .btn-default{width:100%}.employee-type-switch .btn-default.selected{background:#2e68b1;color:#fff}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/annual-report/annual-report.component.scss
// module id = 519
// module chunks = 0